module.exports = __webpack_public_path__ + "fonts/Lato-Hairline.f05daf8b.woff";